import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary:   '#662D91',
        secondary: '#A381BD',
        accent:    '#A381BD',
      },
    },
  },
});
